<template>
  <div>
    <slot name="before"></slot>
    <component v-if="!!currentComponent" v-bind="viewData" :is="currentComponent"></component>
    <div class="zj-errmsg" v-else><span>{{errmsg}}</span></div>
    <slot name="default"></slot>
    <slot name="after"></slot>
  </div>
</template>

<script>
import Vue from 'vue'
//import utils from '../utils'

export default {
  name: 'ZjDynamicContainer',
  props: {
    view: [String, Function, Object],
    viewData: [Object, Function]
  },
  computed: {
    errmsg() {
      return '无法显示菜单 ' + this.view;
    },
    currentComponent() {
      let view = this.view;
      let cmp = null;
      if (!view) {
        return null;
      }
      if (typeof view === 'string') {
        cmp = Vue.component(view)
      }
      else if (typeof view === 'function') {
        cmp = view.apply(this, [view, this.viewData]);
      }
      else {
        cmp = view;
      }
      if (!view) {
        return null;
      }
      return cmp
    }
  }
}
</script>
